/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */

import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";

export default class PatientInfoService extends MainService {
  static getConsultationformation(params) {
    return this.postSEC(ServiceConstant.CONSULTATION_GET_INFO, params);
  }
  static getStudyInformations(params) {
    return this.postSEC(ServiceConstant.STUDY_GET_INFO, params);
  }
}
